import React from "react";
import LegalLayout from "../components/LegalLayout";

const COMPANY = {
  email: "info@nalise.it",
};

const Section = ({ title, children }) => (
  <section className="space-y-3">
    <h2 className="font-display font-bold text-2xl text-slate-900">{title}</h2>
    {children}
  </section>
);

const CookiePage = () => (
  <LegalLayout title="Cookie Policy" lastUpdate="Febbraio 2026">
    <p>
      Il presente documento descrive l'utilizzo dei cookie e di tecnologie analoghe
      sul sito Bottega di Nalise, in conformità al Provvedimento del Garante per la
      Protezione dei Dati Personali del 10 giugno 2021.
    </p>

    <Section title="1. Cosa sono i cookie">
      <p>
        I cookie sono piccoli file di testo che i siti visitati inviano al terminale
        dell'utente, dove vengono memorizzati per essere poi ritrasmessi al sito alla
        successiva visita. Permettono di memorizzare informazioni sulle preferenze del
        visitatore e migliorare l'esperienza di navigazione.
      </p>
    </Section>

    <Section title="2. Cookie utilizzati da questo sito">
      <p>
        <strong>Cookie tecnici (sempre attivi)</strong>: indispensabili per il
        funzionamento del sito. Memorizzano la lingua selezionata (IT/EN), il contenuto
        del carrello, la lista dei preferiti e l'identificativo della sessione chat con
        OBI. Sono salvati nel localStorage del browser e non richiedono consenso.
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li><code className="bg-slate-100 px-1 rounded">nalise_lang</code> — lingua dell'interfaccia</li>
        <li><code className="bg-slate-100 px-1 rounded">nalise_cart</code> — contenuto del carrello</li>
        <li><code className="bg-slate-100 px-1 rounded">nalise_wishlist</code> — prodotti preferiti</li>
        <li><code className="bg-slate-100 px-1 rounded">obi_session_id</code> — identificativo chat OBI</li>
        <li><code className="bg-slate-100 px-1 rounded">obi_messages</code> — cronologia chat OBI</li>
      </ul>
      <p>
        <strong>Cookie di terze parti</strong>: il sito si appoggia a WooCommerce e
        PayPal per la finalizzazione del pagamento. Durante il checkout l'utente viene
        reindirizzato a tali servizi, che utilizzano i propri cookie soggetti alle
        rispettive informative privacy:
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li><a href="https://www.paypal.com/it/webapps/mpp/ua/privacy-full" target="_blank" rel="noopener noreferrer" className="text-sky-600 underline">Informativa Privacy PayPal</a></li>
        <li><a href="https://woocommerce.com/document/woocommerce-cookies/" target="_blank" rel="noopener noreferrer" className="text-sky-600 underline">Cookie WooCommerce</a></li>
      </ul>
      <p>
        <strong>Cookie analitici (con consenso)</strong>: con il tuo consenso, attiviamo{" "}
        <strong>Google Analytics 4</strong> (Measurement ID <code className="bg-slate-100 px-1 rounded">G-9VZDRNSD57</code>)
        per raccogliere statistiche di navigazione anonime (pagine visitate, prodotti
        più popolari, percorso di acquisto). L'indirizzo IP è anonimizzato e Google
        Consent Mode v2 garantisce che nessun cookie analitico venga rilasciato finché
        non accetti dal banner. I dati sono trattati da Google Ireland Ltd. e potrebbero
        essere trasferiti in paesi extra-UE secondo le{" "}
        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-sky-600 underline">policy Google</a>.
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li><code className="bg-slate-100 px-1 rounded">_ga</code>, <code className="bg-slate-100 px-1 rounded">_ga_*</code> — Google Analytics 4 (durata 2 anni, anonimizzato)</li>
      </ul>
    </Section>

    <Section title="3. Come gestire i cookie">
      <p>
        L'utente può gestire le proprie preferenze cookie:
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Cliccando il pulsante qui sotto per riaprire il banner di consenso e modificare la tua scelta in qualsiasi momento.{" "}
          <button
            type="button"
            onClick={() => {
              try { localStorage.removeItem("nalise_cookie_consent"); } catch (e) {}
              window.location.reload();
            }}
            className="ml-2 cartoon-btn bg-yellow-300 hover:bg-yellow-200 text-xs py-1.5 px-3"
            data-testid="reopen-cookie-banner"
          >
            Gestisci cookie
          </button>
        </li>
        <li>Modificando le impostazioni del proprio browser</li>
        <li>Eliminando lo storage locale del sito direttamente dalle impostazioni del browser</li>
      </ul>
      <p>Link rapidi per la gestione dei cookie nei principali browser:</p>
      <ul className="list-disc pl-6 space-y-1">
        <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-sky-600 underline">Google Chrome</a></li>
        <li><a href="https://support.mozilla.org/it/kb/Gestione%20dei%20cookie" target="_blank" rel="noopener noreferrer" className="text-sky-600 underline">Mozilla Firefox</a></li>
        <li><a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-sky-600 underline">Apple Safari</a></li>
        <li><a href="https://support.microsoft.com/it-it/microsoft-edge/eliminare-i-cookie-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="text-sky-600 underline">Microsoft Edge</a></li>
      </ul>
    </Section>

    <Section title="4. Contatti">
      <p>
        Per qualsiasi richiesta relativa ai cookie o alla privacy puoi scrivere a{" "}
        <a href={`mailto:${COMPANY.email}`} className="text-sky-600 underline">{COMPANY.email}</a>.
      </p>
    </Section>

    <p className="text-sm text-slate-500 pt-6 border-t">
      Documento di esempio. Aggiornare in caso di attivazione di cookie analitici o di
      marketing di terze parti.
    </p>
  </LegalLayout>
);

export default CookiePage;
